import isNull from 'lodash/isNull';
import pickBy from 'lodash/pickBy';
import uniq from 'lodash/uniq';
import { DEFAULT_USAGES } from '~/constants/currents';

export const state = () => ({
  search: {},
  temp: {}
});

export const mutations = {
  addAddon (state, addon) {
    const addons = state.search.addons || [];
    addons.push(addon);
    state.search.addons = uniq(addons);
  },
  clear (state) {
    state.search = {};
    state.temp = {};
  },
  clearCarInsuranceAddons (state) {
    state.search.addons = [];
  },
  reset (state, payload) {
    const newSearch = { ...defaultSearches[payload.type], ...(payload.search || {}) };
    if (payload.type === 'lifeInsurance') {
      newSearch['cover_type'] = { ...this.getters['products/getCoverType'] }['code'];
      if (newSearch['illness1'] === null) {
        newSearch['illness1'] = defaultSearches['lifeInsurance'].illness1;
      }
      if (newSearch['serious_illness'] === false) {
        newSearch['accelerated'] = null;
      }
    }
    state.search = newSearch;
  },
  set (state, payload) {
    state.search = { ...state.search, ...payload };
  },
  SET_CURRENT_SEARCH (state, payload) {
    const usages = {
      ...DEFAULT_USAGES,
      ...pickBy((payload.usages || {}), u => !isNull(u))
    };
    payload = pickBy(payload, a => !isNull(a));
    payload.usages = usages;
    state.search = { ...state.search, ...payload };
  },
  setTemp (state, temp) {
    state.temp = { ...state.temp, ...temp };
  },
  setSearchAndTemp (state, newSearch) {
    state.search = { ...state.search, ...newSearch };
    state.temp = { ...state.search, ...newSearch };
  },
  removeSpecifiedItem (state, item) {
    const markedItems = state.search.home_insurance_specified_items.map(i => {
      if (i === item) i._destroy = '1';
      return i;
    });
    state.search.home_insurance_specified_items = markedItems;
  }
};

export const getters = {
  get (state) {
    return state.search;
  },
  getAvailabilities (state) {
    return state.search.availabilities;
  },
  getBroadbandProducts (state) {
    const p = {};
    ['broadband', 'mobile', 'phone', 'tv'].forEach(product => {
      p[product] = !!state.search[product];
    });
    return p;
  },
  getTemp (state) {
    return state.temp;
  }
};

const defaultSearches = {
  broadband: {
    current_provider: '',
    preference_in_broadband: 'PRICE',
    speed: 'all_speeds',
    include_wireless: true
  },
  carInsurance: {
    claims_total: '',
    current_insurer_id: '',
    licence_years_held: '',
    mileage: '',
    named_driver_claims_free_years: '',
    named_driver_policy_insurer_id: 'none',
    no_claims_years: '',
    payment_type: 'yes',
    penalty_points: 'no_points',
    plan_type: '',
    policy_level_excess: 250,
    relationship_id: '',
    value: 500,
    windscreen_claims_total: '',
    existing_policy_life: false,
    existing_policy_home: false,
    existing_policy_mp: false,
    existing_policy_insurer_id_life: '',
    existing_policy_insurer_id_home: '',
    existing_policy_insurer_id_mp: ''
  },
  current: {
    account_type: 'standard',
    normalUsage: true,
    usages: DEFAULT_USAGES
  },
  healthInsurance: {
    spouse: false,
    existing_cover: false,
    dependents: false,
    existing_plan_provider: '',
    existing_plan_name: '',
    renewal_date: '',
    dependents_0_to_17: 0,
    dependents_18_to_24: 0,
    dependents_25_plus: 0,
    tacs_agreed: false
  },
  homeInsurance: {
    bathrooms: '',
    bedrooms: '',
    burglar_alarm: '',
    claims_criteria: null,
    claims_free_years: '',
    contents_cover: 0,
    heating_system: '',
    home_type: '',
    home_use: '',
    rebuilding_cost: 0,
    registered_owner: null,
    roof_felt: 'less_20',
    standard_construction: null,
    year_building_constructed: ''
  },
  lifeInsurance: {
    additional_person: false,
    accelerated: null,
    convertible: false,
    dob: null,
    dob2: null,
    escalation: false,
    illness1: 50000,
    illness2: null,
    indexation: false,
    life1: 200000,
    life2: null,
    policy_type: 'dual',
    previous_institution_id: '',
    retirement_age: '',
    replacement_policy: false,
    serious_illness: false,
    smoker2: null,
    term: 10
  },
  loan: {
    amount: 5000,
    rate_type: 'ALL',
    term: 3
  },
  mortgage: {
    amount: '',
    ber: 0,
    home_value: '',
    purpose: '',
    rate: null,
    rtc: null,
    sort_order: 'monthly_repayment',
    page: 1,
    term: 5,
    rateType: 'ALL',
    fixed_period_years: '',
    joint_application: false
  },
  saving: {
    accounttype: 'EASY',
    amount: 1000,
    bankratingisimportant: false,
    childsaver: false,
    instantaccess: false,
    notice: '',
    savingstype: 'REG'
  }
};
